import React, {useEffect, useState } from 'react';
import { Box, Container, IconButton, Typography} from '@mui/material';
import DSCourseCard from '../../components/DSCourseCard';
import {ReactComponent as RightArrowIcon} from '../../static/icons/CaretArrow.svg'
import {ReactComponent as LeftArrowIcon} from '../../static/icons/CaretArrow.svg'
import {ReactComponent as RoadmapStarIcon} from '../../static/icons/Personalised_Roadmap_Star.svg'
//import DSPerformanceCard from '../../components/DSPerformanceCard';
//import RoadmapOverlay from '../../components/RoadmapOverlay';
import {CookingPreview} from '../../components/CookingSoon';
import { getRecommendedQuestions } from '../../api/axios';
import {motion, AnimatePresece} from 'framer-motion'
import RefreshIcon from '@mui/icons-material/Refresh';

const Dashboard = () => {
  const [currentIndex, setCurrentIndex] = useState(5)
  const [recommendedTopicQuestions, setRecommendedTopicQuestions] = useState([])
  const [visibleCourse, setVisibleCourse] = useState([])
  const [refresh, setRefresh] = useState(false)

  const performance = ["Topic Performance", "Activity", "Common Mistakes"]

  useEffect(() => {
    
    const fetchAllRecommendedTopicQuestions = async () => {
      const response = await getRecommendedQuestions(false); // Add Argument False to Specify refresh = false
      const entries =  Object.entries(response.data)
      if (entries.length < 6) {
        const needed = 6 - entries.length
        console.log([...entries, ...entries.slice(0, needed)])
        setCurrentIndex(entries.length)
        setVisibleCourse(entries.slice(0, entries.length))
        setRecommendedTopicQuestions([...entries, ...entries.slice(0, needed)])
      }
      else {
        setCurrentIndex(5)
        setVisibleCourse(entries.slice(0, 5))
        setRecommendedTopicQuestions(entries)
      }
      
    }
    fetchAllRecommendedTopicQuestions();
  }, [])

  const handleRefresh = async () => {
    setRefresh(true)

    try {
      const response = await getRecommendedQuestions(true); // Add Argument true to Specify refresh = true
      const entries =  Object.entries(response.data)
      if (entries.length < 6) {
        const needed = 6 - entries.length
        console.log([...entries, ...entries.slice(0, needed)])
        setCurrentIndex(entries.length)
        setVisibleCourse(entries.slice(0, entries.length))
        setRecommendedTopicQuestions([...entries, ...entries.slice(0, needed)])
      }
      else {
        setCurrentIndex(5)
        setVisibleCourse(entries.slice(0, 5))
        setRecommendedTopicQuestions(entries)
      }  
    } catch (error) {
      console.log("Get New Recommendation Failed: ", error)
    } finally {
      setRefresh(false)
    }

    setTimeout(() => setRefresh(false), 1000)
  }

  const handleLeftClick = () => {
    console.log(...visibleCourse.slice(1))
    if (currentIndex < recommendedTopicQuestions.length) {
      // Remove the first card and add the next card in the list
      setVisibleCourse((prevCourse) => [
        ...prevCourse.slice(1), // Remove the first card
        recommendedTopicQuestions[currentIndex],   // Add the next card
      ]);
      setCurrentIndex((prevIndex) => (prevIndex + 1) % recommendedTopicQuestions.length); // Increment the index
    }
  }
  
  const handleRightClick= () => {
    if (currentIndex < recommendedTopicQuestions.length) {
      // Remove the first card and add the next card in the list
      setVisibleCourse((prevCourse) => [
        recommendedTopicQuestions[currentIndex],   // Add the next card
        ...prevCourse.slice(0,4), // Remove the lastcard
      ]);
      setCurrentIndex((prevIndex) => prevIndex === 0 ? recommendedTopicQuestions.length - 1 : prevIndex - 1); // Increment the index
    }
  }


  return (
    <Box sx={{height:'100%', display:'flex', flexDirection:'column', justifyContent: 'space-evenly'}}>
        <Container sx={{display:'flex', flexDirection:'row', color:'white', paddingTop:'30px'}}>
          {/* <Typography variant='h5'>Welcome back!</Typography> */}
          <Typography variant='h5' 
          sx={{
            background: "linear-gradient(15deg, #A29EDA 30%, #B292D1 20%, #963F90 60%, #6B3A8F 80%, #351149 80%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent"
          }}></Typography>
        </Container>
        <Container sx={{width: '100%', color:'white', display:'flex', flexDirection:'row', justifyContent: 'space-between', marginY:'20px'}}>
          <Box sx={{color:'white', display:'flex', flexDirection:'row',}} data-cy='welcome-section'>
            <RoadmapStarIcon />
            <Typography variant='h6' marginLeft={'10px'}>Personalized Roadmap</Typography> 
          </Box>
          <Box sx={{color:'white', display:'flex', flexDirection:'row',}}>
            <Typography variant='h6' marginRight={'10px'}>Get New Recommeendation</Typography> 
            <IconButton onClick={handleRefresh} sx={{color: '#B292D1', p: 0}} data-cy='newrecommendation-button'>
              <RefreshIcon
                sx={{
                  fontSize: '30px',
                  animation: refresh ? 'spin360 1s linear infinite' : 'none',
                  '@keyframes spin360': {
                    from: { transform: 'rotate(0deg)' },
                    to: { transform: 'rotate(360deg)' },
                },
              }}/>
            </IconButton>
          </Box>
        </Container>
        <Container sx={{display:'flex', flexDirection:"row", justifyContent:'center', alignItems:'center', width:'100%', height:'50%'}}>
          {console.log(visibleCourse)}
          {visibleCourse.map((course, index) => {
            return (
              <Box 
              data-cy='roadmap-cards'
              key={course[0]}
              sx={{            
                position:'absolute',
                top: '10%',
                transform: 
                `rotate(${index === 0 ? "-15deg" : index === 1 ? "-10deg" : index === 2 ? "0deg" : index === 3 ? "10deg" : "15deg"}) 
                translate(${index === 0 ? "-450px" : index === 1 ? "-350px" : index === 2 ? "0px" : index === 3 ? "350px" : "450px"}, 
                ${index === 2 ? "0px" : "-50px"})`,
                zIndex: index === 0 || index === 4 ? -2 : index === 2 ? 0 : -1,
                width: `${index === 0 || index === 1 || index === 3 || index === 4? "18%" : "40%"}`,
                height: '40%',
                opacity: index === 0 || index === 4 ? 0: 1,
                transition: 'all 1s ease-in-out',
              }}>
                {console.log("Card Index:", index)}
                {console.log("Transform:", `rotate(${index === 0 ? "-10deg" : index === 1 ? "0deg" : "10deg"})`)}
                <DSCourseCard 
                sx={{
                  width: '100%',
                  height: '100%',
                  borderRadius: 10,
                  background: index === 0 || index === 1 || index === 3 || index === 4 ? "linear-gradient(142deg, #6B3A8F -1.88%, #499CA3 196.69%)": "linear-gradient(144deg, #1D151D 42.84%, #4E2D33 179.39%)",
                  color: 'white',
                  border: "2px solid #6b3a8f",
                }}
                  topicName={course[0]} 
                  questions={course[1]}
                  index={index}
                  cooking={index === 2} />
              </Box>
            )
          })}
          <Box sx={{position:'absolute', top: '40%'}}>
            <LeftArrowIcon 
            data-cy='leftarrow-icon'
            style={{
              transform:'rotate(180deg)', 
              cursor:"pointer", 
              marginRight:'400px',
              transition: "transform 0.2s ease", // Smooth enlarge effect
              }}
              onMouseEnter={(e) => (e.currentTarget.style.transform = "rotate(180deg) scale(1.4)")} // Enlarge on hover
              onMouseLeave={(e) => (e.currentTarget.style.transform = "rotate(180deg) scale(1)")} // Reset on leave
              onClick={handleLeftClick}
            />
            <RightArrowIcon 
            data-cy='rightarrow-icon'
            style={{
              cursor:"pointer", 
              marginLeft:'400px',
              transition: "transform 0.2s ease-in-out", // Smooth enlarge effect
              }}
              onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.4)")} // Enlarge on hover
              onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")} // Reset on leave
              onClick={handleRightClick}
            />
          </Box>
        </Container>
        <Container sx={{color:'white'}}>
          <br/><br/>
          <Typography variant='h6'>Progress Analytics</Typography> 
        </Container>
        <Container sx={{width:'55%', height:'55%', display:'flex', flexDirection:'row', justifyContent:'space-around', alignItems:'center'}}>
              {/* {performance.map((kind, index) => {
                return (
                  <DSPerformanceCard 
                  key={index}
                  kind={kind}
                  sx={{
                    width: '30%',
                    height: '80%',
                    // marginLeft:"100px",
                    flex: '0 0 auto',
                    borderRadius: 10,
                    background: index === 0 ? 'rgba(26, 22, 84, 0.8)' : index === 1 ? 'rgba(12, 84, 58, 0.8)' : 'rgba(97, 28, 28, 0.8)',
                    color: 'white',
                }}
                  />
                )
              })} */}
              <CookingPreview/> 
        </Container>
    </Box>
  )
}

export default Dashboard;